// Shared by the <BestSellers> cards and the home-page Product JSON-LD
// (see (home)/components/Schema.js) so the structured data can never
// drift from the prices the cards actually display.
export const bestSellersArray = [
    {
        id: "5",
        model: "Toyota Corolla",
        year: "2023",
        image: "/assets/images/best-sellers/2023-toyota-corolla.jpg",
        transmission: "Automatic",
        category: "City & Highway / FWD",
        prices: [
            { id: "1", name: "1-3 Day(s)", price: 52, currency: "€" },
            { id: "2", name: "4-6 Days", price: 45, currency: "€" },
            { id: "3", name: "7-13 Days", price: 41, currency: "€" },
            { id: "4", name: "14+ Days", price: 37, currency: "€" }
        ]
    },
    {
        id: "7",
        model: "Toyota C-HR",
        year: "2023–2024",
        image: "/assets/images/best-sellers/2023-2024-toyota-chr.jpg",
        transmission: "Automatic",
        category: "Easy Off Road",
        prices: [
            { id: "1", name: "1-3 Day(s)", price: 58, currency: "€" },
            { id: "2", name: "4-6 Days", price: 50, currency: "€" },
            { id: "3", name: "7-13 Days", price: 47, currency: "€" },
            { id: "4", name: "14+ Days", price: 43, currency: "€" }
        ]
    },
    {
        id: "6",
        model: "Suzuki S-Cross",
        year: "2023",
        image: "/assets/images/best-sellers/2023-suzuki-s-cross.jpg",
        transmission: "Automatic",
        category: "Easy Off Road",
        prices: [
            { id: "1", name: "1-3 Day(s)", price: 60, currency: "€" },
            { id: "2", name: "4-6 Days", price: 53, currency: "€" },
            { id: "3", name: "7-13 Days", price: 50, currency: "€" },
            { id: "4", name: "14+ Days", price: 46, currency: "€" }
        ]
    },
    {
        id: "8",
        model: "Toyota Fortuner",
        year: "2022–2024",
        image: "/assets/images/best-sellers/2022-2024-toyota-fortuner.jpg",
        transmission: "Automatic",
        category: "Difficult Off Road",
        prices: [
            { id: "1", name: "1-3 Day(s)", price: 78, currency: "€" },
            { id: "2", name: "4-6 Days", price: 71, currency: "€" },
            { id: "3", name: "7-13 Days", price: 68, currency: "€" },
            { id: "4", name: "14+ Days", price: 64, currency: "€" }
        ]
    }
];
